import actions from './actions'

export default function ContractPartnerPersonsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_CONTRACTPARTNERPERSON:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_CONTRACTPARTNERPERSON:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_CONTRACTPARTNERPERSON:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_CONTRACTPARTNERPERSON:
      return {
        ...state,
        editing: { contractPartnerPersonID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.SAVE_CONTRACTPARTNERPERSON_RECIEVED:
    case actions.DELETE_CONTRACTPARTNERPERSON_RECIEVED:
      return {
        ...state,
        editing: { contractPartnerPersonID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
